





































































































































import { defineComponent, ref } from '@vue/composition-api';
import moment from 'moment';

import { ITariffRegion } from '@/models';
import {
  useFetchTariffRegions,
  useDeleteTariffRegion
} from '@/composable/tariffs';
import authMixin from '@/mixins/auth';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import TariffRegionFormDialog from '@/components/tariff/TariffRegionFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default defineComponent({
  name: 'TariffRegionListPage',
  mixins: [authMixin],
  components: {
    ALPage,
    ConfirmationDialog,
    ErrorAlert,
    TariffRegionFormDialog
  },
  setup(_) {
    //We use a separate ref for the search model in order to not update the queryKey once the search is updated
    const currentSearch = ref<string>('');

    const headers = [
      { text: '#', value: 'index', sortable: false, width: 5 },
      { text: 'Name', value: 'name', sortable: false },
      { text: '', value: 'actions', sortable: false, width: 100 }
    ];

    const dialog = ref(false);
    const selectedTariffRegion = ref<ITariffRegion | null>(null);

    function openTariffRegionDialog(tariffRegion?: ITariffRegion) {
      dialog.value = true;
      selectedTariffRegion.value = tariffRegion ?? null;
    }

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deleteTariffRegion,
      reset: deleteReset
    } = useDeleteTariffRegion();

    const deleteDialog = ref(false);
    function openDeleteTariffRegionDialog(tariffRegion: ITariffRegion) {
      selectedTariffRegion.value = tariffRegion;
      deleteDialog.value = true;
    }

    function closeDrawerAndDialog() {
      drawer.value = false;
      deleteDialog.value = false;
    }

    function removeTariffRegion(vehicle: ITariffRegion) {
      deleteTariffRegion(vehicle.id!, {
        onSuccess: () => {
          closeDrawerAndDialog();
        }
      });
    }

    function clearAllErrors() {
      deleteReset();
      error.value = null;
    }

    const { tariffRegions, error, isLoading } = useFetchTariffRegions();

    const drawer = ref(false);
    function openTariffRegionDrawer(tariffRegion: ITariffRegion) {
      selectedTariffRegion.value = tariffRegion;
      drawer.value = true;
    }

    return {
      deleteInProgress,
      deleteDialog,
      deleteError,
      drawer,
      selectedTariffRegion,
      moment,
      dialog,
      currentSearch,
      tariffRegions,
      isLoading,
      headers,
      error,
      openTariffRegionDialog,
      clearAllErrors,
      openDeleteTariffRegionDialog,
      openTariffRegionDrawer,
      closeDrawerAndDialog,
      removeTariffRegion
    };
  }
});
